import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontText, hexToRgbA, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    font: fontText('normal', theme.fontSize.s, 21),
    color: theme.color.greys[80],
  },
  isDisabled: {
    color: hexToRgbA(theme.color.greys[80], 0.4),
  }
}), { name: 'FieldHelperText', index: StylesIndexInjections.UI_ATOMS });
